"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isError = exports.isString = exports.noop = exports.throttle = void 0;
function throttle(callback, ms) {
    var throttlePause = false;
    return function (t) {
        if (throttlePause)
            return;
        throttlePause = true;
        callback(t);
        setTimeout(function () {
            throttlePause = false;
        }, ms);
    };
}
exports.throttle = throttle;
function noop() { }
exports.noop = noop;
function isString(str) {
    return typeof str === "string";
}
exports.isString = isString;
function isError(err) {
    if (!err)
        return false;
    if (err instanceof Error)
        return true;
    if (typeof err !== "object")
        return false;
    return (typeof err.name === "string" && err.message === "string");
}
exports.isError = isError;
//# sourceMappingURL=util.js.map